import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopupComponent } from '../popup/popup.component';
import { NgClass, NgIf } from '@angular/common';
import { IdNameModel } from '../../../models/idname.model';

@Component({
  selector: 'app-select-popup',
  standalone: true,
  imports: [
    NgIf,
    NgClass
  ],
  templateUrl: '../popup/popup.component.html',
  styleUrls: [
    '../popup/popup.component.scss',
    './select-popup.component.scss'
  ]
})
export class SelectPopupComponent extends PopupComponent implements AfterViewChecked, OnInit {
  @Input() public title: string = '';
  @Input() public hint: string = '';
  @Output() public selected: EventEmitter<IdNameModel> = new EventEmitter<IdNameModel>();

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterViewChecked() {
    super.ngAfterViewChecked();
    this.bindExtraData();
  }

  protected bindExtraData() {
    if (this.component) {
      this.component.instance.title = this.title;
      this.component.instance.hint = this.hint;
      this.component.instance.selectedChange?.subscribe((o: any) => {
        if (o) {
          this.selected.emit(o);
        }
      })
    }
  }
}
